import React, { useState, useEffect } from "react";
import useHttp from "../../hooks/use-http";
import { toast } from "react-toastify";
import { utils, read } from "xlsx";
import ReactFileReader from "react-file-reader";
import Pagination from "../../components/Pagination";
import moment from "moment";

const FarmerGoodsIssuedUploadFMN = () => {
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [formData, setFormData] = useState();
  const [areaData, setAreaData] = useState([]);  
  const [departmentData, setDepartmentData] = useState([]);  
  const [designationData, setDesignationData] = useState([]);  
  const [seasonData, setSeasonData] = useState([]);  
  const [productList, setProductList] = useState([]);  
  
  
  const [regionData, setRegionData] = useState([]);
  const [variety, setVariety] = useState([]);
  
  const[farmerData,setFarmerData] = useState([]);
  const[farmerCropPlotData,setFarmerCropPlotData] = useState([]);
  const[warehouseData,setWarehouseData] = useState([]);
  var d = new Date();
  var dateString =
    d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear() +" "+d.getHours() + ":"+d.getMinutes()+ ":"+d.getSeconds();


  
  const {

      sendRequest: getArea,
    } = useHttp();
  



  const {

    sendRequest: getRegion,
  } = useHttp();

  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("region", data);

        setRegionData(data.data);
      
      }
    );
  }, [getRegion]);



  const { sendRequest: getWarehouseData } = useHttp();


  useEffect(() => {
    getWarehouseData(
      {
        // url: "/api/warehouses/",
        url: `/api/warehouses/?orgId=${localStorage.getItem("orgId")}&&storeTypeId=1&&createdBy=${localStorage.getItem("id")}`,
      },
      (data) => {
        console.log("region", data);

        setWarehouseData(data);
      
      }
    );
  }, [getWarehouseData]);


 


  const {

    sendRequest: getvarieties,
  } = useHttp();

  useEffect(() => {
    getvarieties(
      {
        url: "/api/varieties/",
      },
      (data) => {
        //console.log("region", data);

        setVariety(data);
      
      }
    );
  }, [getvarieties]);


  
  const {

    sendRequest: getfarmer,
  } = useHttp();

  useEffect(() => {
    getfarmer(
      {
        url: `/api/farmerListForSelection/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        console.log("farmerListForSelection", data);

        setFarmerData(data);
      
      }
    );
  }, [getfarmer]);



  const {

    sendRequest: getfarmerPlot,
  } = useHttp();


  useEffect(() => {
    getfarmerPlot(
      {
        url: `/api/farmerCropReport/?orgId=${localStorage.getItem("orgId")}&&empId=${localStorage.getItem("empId")}`,
      },
      (data) => {
        console.log("farmerCropReport", data);

        setFarmerCropPlotData(data);
      
      }
    );
  }, [getfarmerPlot]);

  useEffect(() => {
      getArea(
        {
          url: `/api/areaDetails/?orgId=${localStorage.getItem("orgId")}`,
        },
        (data) => {
          //console.log("region", data);
  
          setAreaData(data);
        
        }
      );
    }, [getArea]);
  

    const {

      sendRequest: getDesignation,
    } = useHttp();

    
    useEffect(() => {
      getDesignation(
        {
          url: `/api/designation/?orgId=${localStorage.getItem("orgId")}`,
        },
        (data) => {
          // console.log(data);
          setDesignationData(data);
        }
      );
    }, [getDesignation]);


    const {

      sendRequest: getDepartment,
    } = useHttp();

    useEffect(() => {
      getDepartment(
        {
          url: `/api/department/?orgId=${localStorage.getItem("orgId")}`,
        },
        (data) => {
          //console.log(data);
          setDepartmentData(data);
        }
      );
    }, [getDepartment]);
  

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setEmployeeData(data.output);
      }
    );
  }, [getEmp]);



  const { sendRequest: getproduct } = useHttp();
  useEffect(() => {
    getproduct(
      {
        url: `/api/fillAgroFertlizerSeedProductList/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setProductList(data);
      }
    );
  }, [getproduct]);


  




  const {

    sendRequest: getSeasonList,
  } = useHttp();

  useEffect(() => {
    getSeasonList(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
         setSeasonData(data);
      }
    );
  }, [getSeasonList]);


  function generateUniqueID() {
    const currentDateTime = new Date();
    const uniqueID =
      currentDateTime.getTime() + Math.floor(Math.random() * 1000);

    return uniqueID.toString();
  }

  const handleFileRead = (e) => {
    const content = e.target.result;
    const workbook = read(content, { type: "binary" });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const parsedData1 = utils.sheet_to_json(worksheet, { header: 1 });
    
    const parsedData=parsedData1.filter(item=>item[0]!="");
    console.log(parsedData);
    setData(parsedData);
    setAllData(parsedData);
   
    const headers = parsedData[0];
    var tempplotId= generateUniqueID ()
    var counterId=1;
    const jsonData = parsedData.slice(1).map((row,index) => {
      
      const employeeCode= row[headers.indexOf("Employee Code")];
       
      var farmerNo= row[headers.indexOf("Farmer Code")];
      var warehouseName= row[headers.indexOf("Store Name")];

      
      console.log("farmerNo",farmerNo)  
      console.log("employeeCode",employeeCode) 
      
      const fieldExecutive = employeeData.find(
        (employee) => employee.employeeCode === employeeCode
      );
      
      console.log("fieldExecutive",fieldExecutive) 
      console.log("farmerData",farmerData) 
      
      const farmerobj = farmerData.find(
        (farmerItem) => farmerItem.farmerNo === farmerNo
      );

      console.log("farmerobj",farmerobj) 
      console.log("farmerCropPlotData",farmerCropPlotData) 
      const cropobj = farmerCropPlotData.find(
        (farmerItem) => farmerItem.farmerNo === farmerNo
      );
      console.log("cropobj",cropobj) 

      console.log("warehouseName",warehouseName)
      console.log("warehouseData",warehouseData)
      const warehouseObj = warehouseData.find(
        (farmerItem) => farmerItem.name === warehouseName
      );
      console.log("warehouseObj",warehouseObj) 

      
      
      var latitude  = row[headers.indexOf("Latitude")];
      var longitude = row[headers.indexOf("Longitude")];
      var plotCoordinates='[{\"latitude\":'+latitude+',\"longitude\":'+longitude+'}]';

      var goodIssueId=tempplotId+counterId.toString()
      counterId=counterId+1;
        
       
      var disdate=row[headers.indexOf("Distribution date")]
      
       
      let distribution_date = new Date(Math.round((disdate - 25569) * 864e5));
      distribution_date = moment(distribution_date).format('DD/MM/YYYY')
      console.log("distribution_date",distribution_date) 
       
      var cropsDetails ='[{\"cropType\":\"Grains\",\"cropName\":\"Wheat\",\"cropVariety\":\"Borlaug\",\"cropVarietyId\":\"8\",\"cropMasterId\":\"4\",\"sowingDate\":\"\",\"transplantingDate\":\"\",\"pruningDate\":\"\",\"harvestingDate\":\"\",\"surveyNumberGutNumber\":\"\",\"plantCount\":\"\",\"growthType\":\"\",\"seasonId\":\"2\",\"farmerInputTemplateId\":\"9\",\"woodlotsPlantedTrees\":\"\",\"woodlotsPlantedTreeCount\":\"\",\"targetTreeSeedlings\":\"\",\"estimateYieldInKg\":\"\",\"class1Rate\":1.0,\"class2Rate\":1.0,\"class3Rate\":1.0,\"class4Rate\":0.0,\"classUnitId\":2}]'
      console.log("productList",productList) 
      
      
      var PreEmergencePendimethalinQty= row[headers.indexOf("Pre-emergence Pendimethalin QTY(Ltrs)")]; 
       const productObj1 = productList.find(
        (pItem) => pItem.productName === 'Pre-emergence Pendimethalin'
      );
      var goodIssuedProductId= goodIssueId+100
      var productItem=[]
        productItem=productItem.concat({
         
        goodIssuedProductId: goodIssuedProductId ,
        goodIssueId:goodIssueId,  
        productId :productObj1.productId,
        availableQty: PreEmergencePendimethalinQty,
        salesRate : 0,
        useQty :PreEmergencePendimethalinQty ,
        productCost : 0,
        isFreeProduct: false,
        availableCost :0, 
        useAmt : 0,
        unitId:productObj1.unitId,
      })

      var cypermethrinQty= row[headers.indexOf("Cypermethrin QTY(Ltrs)")]; 
       const productObj2 = productList.find(
        (pItem) => pItem.productName === 'Insecticide (Cypermethrin)'
      );
      var goodIssuedProductId= goodIssueId+101
      productItem=productItem.concat({
         
        goodIssuedProductId: goodIssuedProductId ,
        goodIssueId:goodIssueId,  
        productId :productObj2.productId,
        availableQty: cypermethrinQty,
        salesRate : 0,
        useQty :cypermethrinQty ,
        productCost : 0,
        isFreeProduct: false,
        availableCost :0, 
        useAmt : 0,
        unitId: productObj2.unitId,
       
      })


      var  SeedcareQty   = row[headers.indexOf("Seedcare QTY(Sachet)")]; 
       const productObj3 = productList.find(
        (pItem) => pItem.productName === 'Seedcare'
      );
      var goodIssuedProductId= goodIssueId+102
      productItem=productItem.concat({
         
        goodIssuedProductId: goodIssuedProductId ,
        goodIssueId:goodIssueId,  
        productId :productObj3.productId,
        availableQty: SeedcareQty,
        salesRate : 0,
        useQty :SeedcareQty ,
        productCost : 0,
        isFreeProduct: false,
        availableCost :0, 
        useAmt : 0,
        unitId: productObj3.unitId,
       
      })

      
      var  GoldenFertilizernp151515Qty   = row[headers.indexOf("Golden Fertilizer NPK 15:15:15 QTY (Kg)")]; 
       const productObj4 = productList.find(
        (pItem) => pItem.productName === 'Golden Fertilizer NPK 15:15:15'
      );
      var goodIssuedProductId= goodIssueId+103
      productItem=productItem.concat({
         
        goodIssuedProductId: goodIssuedProductId ,
        goodIssueId:goodIssueId,  
        productId :productObj4.productId,
        availableQty: GoldenFertilizernp151515Qty,
        salesRate : 0,
        useQty :GoldenFertilizernp151515Qty ,
        productCost : 0,
        isFreeProduct: false,
        availableCost :0, 
        useAmt : 0,
        unitId: productObj4.unitId,
       
      })


      var  GoldenFertilizernp5505Qty   = row[headers.indexOf("Golden Fertilizer NPK 42:0:5 (Urea) QTY in Kg")]; 
       const productObj5 = productList.find(
        (pItem) => pItem.productName === 'Golden Fertilizer NPK 42:0:5 (Urea)'
      );
      var goodIssuedProductId= goodIssueId+104
      productItem=productItem.concat({
         
        goodIssuedProductId: goodIssuedProductId ,
        goodIssueId:goodIssueId,  
        productId :productObj5.productId,
        availableQty: GoldenFertilizernp5505Qty,
        salesRate : 0,
        useQty :GoldenFertilizernp5505Qty ,
        productCost : 0,
        isFreeProduct: false,
        availableCost :0, 
        useAmt : 0,
        unitId: productObj5.unitId,
       
      })



      var  seedQty   = row[headers.indexOf("Seed QTY(Kg)")]; 
       const productObj6 = productList.find(
        (pItem) => pItem.itemId === 'SDWH00001'
      );
      var goodIssuedProductId= goodIssueId+105
      productItem=productItem.concat({
         
        goodIssuedProductId: goodIssuedProductId ,
        goodIssueId:goodIssueId,  
        productId :productObj6.productId,
        availableQty: seedQty,
        salesRate : 0,
        useQty :seedQty ,
        productCost : 0,
        isFreeProduct: false,
        availableCost :0, 
        useAmt : 0,
        unitId: productObj6.unitId,
       
      })

      const employee = {
        goodIssueId:goodIssueId,
        farmerId:farmerobj.farmerId,
        goodsIssueDate:distribution_date, 
        goodsIssueProductDetails:productItem,
         plotId:cropobj.plotId	,	
         cropId:cropobj.cropId,         
         farmerInputTemplateId:cropobj.farmerInputTemplateId,   
        totalAmount:row[headers.indexOf("Amount Due(Naira)")],
        discount:0,
        discountAmount:0,     
        entryLatLong: '{\"latitude\":18.6105081,\"longitude\":73.7651918}',  
        orgId: localStorage.getItem("orgId"),
        empId:fieldExecutive.empId,
        createdBy:fieldExecutive.userId,
        status:1,
        createdDate: dateString,
        warehouseId:warehouseObj.id,  
        logistics:row[headers.indexOf("Logistics")],
       };

      return employee;
    });
    console.log(jsonData);

    
    setFormData(jsonData);
  };




  const handleFileUpload = (files) => {
    const file = files[0];
    const fileReader = new FileReader();
    fileReader.onloadend = handleFileRead;
    fileReader.readAsBinaryString(file);
  };
  const [itemsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber); 
  };

  const { sendRequest: postAddFarmeer } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    postAddFarmeer(
      {
        url: "/api/uploadFarmerGoodsIssue/",
        method: "POST",
        body: formData,
      },
      (data) => {
        toast.success(`Farmeer goods issue added successfully`);
        setFormData("");
        setData([]);
      }
    );
  };
  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">&nbsp;
                <form onSubmit={submitHandler}>
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-10">   <label className="card-title mx-2 my-3 ">
                          FMN Farmer Plot FMN Details
                        </label></div>

                        <div className="col-2">
                          <ReactFileReader
                            handleFiles={handleFileUpload}
                            fileTypes={".xlsx"}
                          >
                            <button
                              type="button"
                              className="btn  btn-primary mx-2 my-2"
                            >
                              Upload Excel
                            </button>
                          </ReactFileReader>{" "}
                        </div>
                      </div>

                      <div className="row">
                        <table className="table table-bordered table-responsive text-center table-sm">
                          <thead>
                            <tr className="tableheaderrowview">
                              {data[0] &&
                                data[0].map((header, index) => (
                                  <th key={index}>{header}</th>
                                ))}
                            </tr>
                          </thead>
                          <tbody>
                            {data &&
                              data.slice(1).map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                  {row.map((cell, cellIndex) => (
                                    <td key={cellIndex}>{cell}</td>
                                  ))}
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {/* /.card-body */}
                    <div className="card-footer clearfix">
                      <Pagination
                        totalItems={data.length}
                        itemsPerPage={itemsPerPage}
                        onPageChange={paginate}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                      />
                    </div>
                  </div>

                  <div className="text-center">
                    <button className="btn  btn-primary mx-2 my-2" type="submit">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerGoodsIssuedUploadFMN;
